import React from "react"
import { Card } from "antd"
import { translations } from "../../utils/Translation/staticTranslation"
import "./Discounts.css"

const DiscountStats = ({ stats, loading = false }) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.discountsPage

  return (
    <div className="discount-stats-container">
      <Card
        className="discount-stat-card"
        bodyStyle={{ padding: "16px", height: "80px" }}
      >
        <div className="discount-stat-content">
          <div className="discount-stat-icon-wrapper discount-stat-icon-wrapper-active">
            <img src="/discounts/active-discount.svg" alt="Active Discounts" />
          </div>
          <div className="discount-stat-text-wrapper">
            <div className="discount-stat-value">{stats?.active || 0}</div>
            <div className="discount-stat-label">
              {t?.stats?.active || "Active Discounts"}
            </div>
          </div>
        </div>
      </Card>

      <Card
        className="discount-stat-card"
        bodyStyle={{ padding: "16px", height: "80px" }}
      >
        <div className="discount-stat-content">
          <div className="discount-stat-icon-wrapper discount-stat-icon-wrapper-expired">
            <img
              src="/discounts/cancel-circle-discount.svg"
              alt="Expired Discounts"
            />
          </div>
          <div className="discount-stat-text-wrapper">
            <div className="discount-stat-value">{stats?.expired || 0}</div>
            <div className="discount-stat-label">
              {t?.stats?.expired || "Expired Discounts"}
            </div>
          </div>
        </div>
      </Card>

      <Card
        className="discount-stat-card"
        bodyStyle={{ padding: "16px", height: "80px" }}
      >
        <div className="discount-stat-content">
          <div className="discount-stat-icon-wrapper discount-stat-icon-wrapper-redemptions">
            <img
              src="/discounts/coupon-percent-discount.svg"
              alt="Total Redemptions"
            />
          </div>
          <div className="discount-stat-text-wrapper">
            <div className="discount-stat-value">
              {stats?.totalRedemptions || 0}
            </div>
            <div className="discount-stat-label">
              {t?.stats?.total_redemptions || "Total Redemptions"}
            </div>
          </div>
        </div>
      </Card>

      <Card
        className="discount-stat-card"
        bodyStyle={{ padding: "16px", height: "80px" }}
      >
        <div className="discount-stat-content">
          <div className="discount-stat-icon-wrapper discount-stat-icon-wrapper-revenue">
            <img src="/discounts/dollar-circle.svg" alt="Revenue Impact" />
          </div>
          <div className="discount-stat-text-wrapper">
            <div className="discount-stat-value">
              SAR{" "}
              {stats?.revenueImpact
                ? stats.revenueImpact.toLocaleString()
                : "0"}
            </div>
            <div className="discount-stat-label">
              {t?.stats?.revenue_impact || "Revenue Impact"}
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default DiscountStats
